import { createReducer } from '@reduxjs/toolkit'
import { BurnState } from 'state/types'
import { EditingField, fetchRemovalOrderUserDataAsync, Field, ClpField, snapshotRemovalOrder, typeInput, typeSmartRemovalInput, resetBurnState } from './actions'

const initialState: BurnState = {
  independentField: Field.LIQUIDITY_PERCENT,
  typedValue: '0',
  inputTokenA: '',
  inputTokenB: '',
  removalOrders: [{
    lpAddress: "",
    userData: {
      allowance: "0",
      stakedBalance: "0",
      hasRuleEnabled: false,
      token0Amt: "0",
      token1Amt: "0",
      pendingVvs: "0"
    },
  }],
  userLoadedData: false,
  editing: EditingField.INSTANT
}

export default createReducer<BurnState>(initialState, (builder) => {
  builder.addCase(typeInput, (state, { payload: { field, typedValue } }) => {
    return {
      ...state,
      independentField: field,
      editing: EditingField.INSTANT,
      typedValue,
    }
  })
  builder.addCase(typeSmartRemovalInput, (state, { payload: { field, typedValue } }) => {
    return {
      ...state,
      editing: EditingField.SMART,
      inputTokenA: field === ClpField.CURRENCY_A ? typedValue : state.inputTokenA,
      inputTokenB: field === ClpField.CURRENCY_B ? typedValue : state.inputTokenB
    }
  })
  builder.addCase(snapshotRemovalOrder, (state, { payload: { key, info } }) => {
    return {
      ...state,
      snapshot: {
        ...state.snapshot,
        [key]: info
      }
    }
  })
  builder.addCase(resetBurnState, (state) => {
    return {
      ...initialState,
      removalOrders: state.removalOrders,
      snapshot: state.snapshot,
    }
  })
  builder.addCase(fetchRemovalOrderUserDataAsync.fulfilled, (state, action) => {
    state.removalOrders = action.payload.map(lp => ({
      lpAddress: lp.lpAddress,
      userData: {
        allowance: lp.allowance,
        stakedBalance: lp.stakedBalance,
        hasRuleEnabled: lp.hasRuleEnabled,
        token0Amt: lp.token0Amt,
        token1Amt: lp.token1Amt,
        pendingVvs: lp.pendingVvs
      }
    }))
    state.userLoadedData = true
  })
})
